const RECAPTCHA_PUBLIC_KEY = "u" > typeof window ? window.RECAPTCHA_PUBLIC_KEY : null;
const URLS = {
    wistia: 'https://fast.wistia.com/assets/external/E-v1.js',
    recaptha: RECAPTCHA_PUBLIC_KEY ? `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_PUBLIC_KEY}` : '',
    stripev2: 'https://js.stripe.com/v2/',
    paypal: 'https://www.paypalobjects.com/api/checkout.js',
    conekta: 'https://cdn.conekta.io/js/latest/conekta.js',
    ebanx: 'https://js.ebanx.com/ebanx-libjs-latest.min.js',
    vidyard: 'https://play.vidyard.com/embed/v4.js',
    payu: "https://gateway.payulatam.com/ppp-web-gateway/javascript/PayU.js",
    youtube: 'https://www.youtube.com/iframe_api',
    rappi: 'https://microservices.dev.rappi.com/rms/merchant-services/sdk/rms.js'
};
const scriptsLoadedCache = [];
function loadScript({ src, async, defer }) {
    return new Promise((resolve, reject)=>{
        if (scriptsLoadedCache.includes(src)) resolve(true);
        else {
            const js = document.createElement("script");
            js.src = src;
            js.type = "text/javascript";
            if (async) js.async = true;
            else if (defer) js.defer = true;
            js.onload = ()=>{
                resolve(true);
                scriptsLoadedCache.push(src);
            };
            js.onerror = reject;
            document.head.appendChild(js);
        }
    });
}
const src_loadScript = loadScript;
export default src_loadScript;
export { URLS };
